import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import Contact from "./sections/Contact";
import Departments from "./sections/Departments";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactHero />
      <Contact />
      <Departments />
      <Footer />
    </div>;
}